import React, {useEffect, useState, useContext} from "react";
import {useNavigate} from "react-router-dom";
import SummaryTable from "./SummaryTable";
import AccountIcon from "./AccountIcon";
import RefreshContext from "../RefreshContext";
import ColumnHeader from "./ColumnHeader";
import TimeRangePicker from "./TimeRangePicker";

export default function Accounts() {
  const [accounts, setAccounts] = useState([]);
  const [chartData, setChartData] = useState(null);
  const {refreshKey} = useContext(RefreshContext);
  const navigate  = useNavigate();

  useEffect(() => {
    const fetchAccounts = async () => {
      const response = await fetch("/api/accounts");
      const data = await response.json();
      setAccounts(data);
    };
    const fetchChartData = async () => {
      const response = await fetch("/api/transactions/time_series_chart");
      const data = await response.json();
      setChartData(data);
    }

    fetchAccounts();
    fetchChartData();
  }, [refreshKey]);

  if (accounts.empty || !chartData) {
    return ""
  }

  return (
    <div className={"row w-100"}>
      <ColumnHeader title="Accounts">
        <TimeRangePicker/>
      </ColumnHeader>
      <div className={"col-12"}>
        {accounts && <SummaryTable
          rows={accounts}
          onRowClick={(account) => {
            navigate(`/accounts/${account.id}`)
          }}
          columns={[
            {
              title: "Account",
              value: "name",
              render: (account) => {
                return <div>
                  <AccountIcon accountType={account.account_type}/>
                  <a href={`/accounts/${account.id}`} className={"ms-2"}>
                    {account.name}
                  </a>

                </div>
              },
            },
            {title: "Last 4", value: "last_four"},
            {title: "Current Balance", value: "balance", type: "currency"},
            {title: "Cashflow", value: "cashflow", type: "currency"}
          ]}/>}
      </div>
    </div>
  );
}
